<script lang="ts" setup>
import { ref, watch, inject, Ref } from "vue";
import { ISectionItem } from "@posx/core";
import { notify } from '@/utils/notification';
import { useSectionStore, useSortedSectionItems } from "@/stores/section";
import { storeToRefs } from "pinia";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const $emit = defineEmits(["change", "update:modelValue", "close", "confirm"]);
const $props = defineProps({
  modelValue: {
    type: Boolean,
  },
});
const sectionItem = inject<Ref<ISectionItem | null>>("sectionItem", ref(null));
const sectionStore = useSectionStore();
const { sectionItems } = storeToRefs(sectionStore);
const { sortedItems: excludeCurrentSectionItem, getSectionName } = useSortedSectionItems({
  currentItem: sectionItem,
  filter: (item) => !item.invoice_uid // only empty tables
});

const targetTable = ref<string>();
const visible = ref($props.modelValue);

watch(
  () => $props.modelValue,
  (newVal: boolean) => {
    visible.value = newVal;
  }
);

const handleClose = () => {
  $emit("change", false);
  $emit("update:modelValue", false);
  $emit("close", false);
};

const handleConfirm = () => {
  if (!targetTable.value) return notify.info(t('components.switch_table.please_select_table'))
  $emit("confirm", sectionItems.value?.find((item: ISectionItem) => item.uid == targetTable.value));
};
</script>

<template>
  <x-dialog
    v-model="visible"
    width="770px"
    :title="t('components.switch_table.title')"
    :before-close="handleClose"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="w-[355px] flex flex-col justify-between">
      <div>
        <div class="mb-4">Current Table: {{ sectionItem?.name }}</div>
        <el-select
          class="w-full"
          :placeholder="t('components.switch_table.placeholder')"
          v-model="targetTable"
        >
          <el-option
            :label="`[${getSectionName(item.section_uid)}] ${item.name}`"
            :value="item.uid"
            v-for="item in excludeCurrentSectionItem"
          ></el-option>
        </el-select>
      </div>
      <div>
        <x-button type="primary" class="w-full" @click="handleConfirm">{{
          t("common.confirm")
        }}</x-button>
      </div>
    </div>
  </x-dialog>
</template>

